import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OcsServices"*/ './lazyIndex'),
    { name: 'OcsServices' }
);

export const lazyReadOcsSettings: LazyAction<typeof lazyIndex.readOcsSettings, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.readOcsSettings);

export const lazyReadLargeRoamingSignatureSettings: LazyAction<
    typeof lazyIndex.readLargeRoamingSignatureSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.readLargeRoamingSignatureSettings);

export const lazyDeleteOcsSettings: LazyAction<
    typeof lazyIndex.deleteOcsSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.deleteOcsSettings);

export const lazyWriteOcsSettings: LazyAction<
    typeof lazyIndex.writeOcsSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.writeOcsSettings);

export const lazyIsWriteOcsSettingsQueuedAction: LazyAction<
    typeof lazyIndex.isWriteOcsSettingsQueuedAction,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.isWriteOcsSettingsQueuedAction);

export const lazyWriteLargeRoamingSignatureSettings: LazyAction<
    typeof lazyIndex.writeLargeRoamingSignatureSettings,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.writeLargeRoamingSignatureSettings);
